import Fuse, { FuseOptions } from 'fuse.js';

const defaultOptions: FuseOptions = {
  threshold: 0.3,
  shouldSort: false,
  caseSensitive: false,
};

export default function fuzzySearch(options: FuseOptions): Function {
  options = { ...defaultOptions, ...options };

  return <T extends { id: string }>(items: T[], searchString: string): T[] => {
    if (!searchString) {
      return items;
    }

    return new Fuse(items, options).search(searchString);
  };
}
